import React from 'react';

interface LitePlanIndicatorProps {
    patient: PatientType;
}
export function LitePlanIndicator({ patient }: LitePlanIndicatorProps) {
    return patient?.metadata?.LitePlanIndicator === true ? (
        <span
            className="lite-plan-indicator ms-2"
            title="This Member’s Benefit Plan is part of a Lite Program."
        >
            L
        </span>
    ) : null;
}
